const HEX_COLOR_REGEX = /^#[0-9A-Fa-f]{6}$/;

export const hexToRgba = (hex: string, alpha: number): string | undefined => {
  if (!HEX_COLOR_REGEX.test(hex)) {
    return undefined;
  }

  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
